import React, { Component } from 'react'
import constant from '../../constant'
import { FAQOurBlog } from '../../action/auth'
import Parser from 'html-react-parser';
import authImage from '../../../src/assets/images/author/blogAuthor.png'
import { getStorage } from '../../utils'
import { PackagesList } from '../../action/package'
import Shimmer from '../Common/Shimmer'
import { Link } from 'react-router-dom';
export default class JobPosting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            packages: undefined
        }
    }
    componentDidMount() {
        // FAQOurBlog().then((res) => {
        //     this.setState({ blogList: res.result.list })
        // }).catch((err) => {
        //     alert(err)
        // })
    }
    
    componentDidMount() {
        PackagesList().then(res => {
            if (res.status) {
                const list = res.result.list.map(i => {
                    i.TOTAL_PRICE = i.PRICE
                    i.QTY = 1
                    return i
                })
                this.setState({ packages: list })
            }
            else {
            }
        })

    }

    onChangeQty = (val, e) => {

        const { packages } = this.state;

        const list = packages.map(i => {
            if (i.PACKAGE_ID == val.PACKAGE_ID) {
                const value = e.target.value
                i.QTY = value
                i.TOTAL_PRICE = +value * val.PRICE
            }
            return i
        })
        // console.log(list)
        this.setState({ packages: list })
    }

    startSubscription = (e, item) => {
        e.preventDefault();
        const tk = getStorage(constant.keys.token)
        if (!tk) {
            this.props.gotoregister()
        }
        else {

            const freeSubscribedPackages = this.props.subscribedList?.find((item) => {
                if (item.AMOUNT == 0) {
                    return item
                }
            })
            if (freeSubscribedPackages && item.PACKAGE_ID == freeSubscribedPackages.PACKAGE_ID) {
                return false
            }

            else {

                const model = {
                    PACKAGE_ID: item.PACKAGE_ID,
                    QTY: item.QTY,
                    PACKAGE_TITLE: item.PACKAGE_TITE,
                    // AMOUNT: item.TOTAL_PRICE
                    AMOUNT: parseInt(e.target.dataset.planPrice, 10)
                }
                this.props.onSubmit(model)
            }
        }
    }
    render() {
        const { subscribedList } = this.props
        const { packages } = this.state
        const tk = getStorage(constant.keys.token)
        const freeSubscribedPackages = subscribedList?.find((item) => {
            if (item.AMOUNT == 0) {
                return item
            }
        })

        return (
            <React.Fragment>
                <section className="pricing-area section-bg padding-top-150px padding-bottom-80px">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-heading text-center">
                                    <h2 className="sec__title_head">POST A JOB</h2>
                                    <p className="sec__desc">Quick & Easy Job Posting − Get Quality Applies</p>
                                </div>
                            </div>
                        </div>
                        <div className="row margin-top-35px">
                            <div className="col-lg-12">
                                <div className="row d-flex">

                                    {(!packages) && <div className="col-lg-12 pr-2">
                                        <Shimmer />

                                    </div>}
                                    {tk && subscribedList && packages && packages.map((item, index) => {
                                        return (
                                            <div className="col-lg-20 pr-2 sq-dbm1">
                                                <div className="package-item sq-dbm1">
                                                    <div className="price margin-bottom-20px sq-dbm1">
                                                        <h3 className="price__title sq-dbm1">{item.PACKAGE_TITE}</h3>
                                                        <p>{item.SUB_TITLE}</p>
                                                        <div className="package-info margin-top-20px sq-dbm1"> 
                                                        {/* {index==1? <span className='silverfont'><span>₹</span><del>30000</del></span> : ""}  */}
                                                            <sup className="dollar sq-dbm1">₹</sup>
                                                            <span className="amount sq-dbm1">{item.TOTAL_PRICE}</span>
                                                        </div>
                                                        <h6 className='text-center pt-2 sq-dbm1'>All Cities</h6>
                                                    </div>
                                                    <ul className="list-items margin-bottom-50px pb-1 sq-dbm1">

                                                        {
                                                            item.PACKAGE_DETAILS.split('\n').map((ele, index) => {
                                                                return (
                                                                    <li><i className={ele.split(',')[0].trim() === 'yes' ? "la la-check-circle text-success" : 'la la-close text-danger'}></i> {ele.split(',').slice(1).join(',')} </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                    {item.SUB_TITLE != "Basic Job Posting" ?
                                                        <div className='row sq-dbm1'>
                                                            {/* <div className='col-md-7 pb-2 sq-dbm1'>
                                                                <div className='d-flex align-items-center sq-dbm1'>
                                                                    <p className='pr-2 sq-dbm1'>Quantity:</p>

                                                                    <select class="form-control p-0 sq-dbm1"
                                                                        value={item.QTY}
                                                                        onChange={(e) => { this.onChangeQty(item, e) }}
                                                                    >
                                                                        <option value="1">01</option>
                                                                        <option value="2">02</option>
                                                                        <option value="3">03</option>
                                                                        <option value="4">04</option>
                                                                        <option value="5">05</option>
                                                                        <option value="6">06</option>
                                                                        <option value="7">07</option>
                                                                        <option value="8">08</option>
                                                                        <option value="9">09</option>
                                                                        <option value="10">10</option>
                                                                    </select>


                                                                </div>
                                                            </div> */}
                                                            {/* <div className={'col-md-5 sq-dbm1'}>
                                                                <div className='d-flex align-items-center sq-dbm1'>
                                                                    <p className='pr-2 sq-dbm1'>Total:</p>
                                                                    <h6>₹{item.TOTAL_PRICE}</h6>
                                                                </div>
                                                            </div> */}

                                                            {/* {item.PRICE == 0 && <div className='col-md-12 sq-dbm1'>
                                                                <p className='bg-light font-size-11 rounded-sm p-1 sq-dbm1'>Flat {item.DISCOUNT}% OFF | Buy 5 Job Postings or more</p>
                                                            </div>} */}
                                                        </div> :

                                                        <div className='row sq-dbm1'>
                                                            <div className='col-md-7 pb-2 sq-dbm1'>
                                                                <div className='d-flex align-items-center sq-dbm1'>

                                                                </div>
                                                            </div>
                                                            {/* <div className='col-md-7 pb-2 sq-dbm1'>
                                                                <div className='d-flex align-items-center sq-dbm1'>
                                                                    <p className='pr-2 sq-dbm1'>Total:</p>
                                                                    <h6>₹{item.PRICE}</h6>
                                                                </div>
                                                            </div> */}
                                                            {/* {item.DISCOUNT != null && item.DISCOUNT > 0 && <div className='col-md-12'>
                                                                <p className='bg-light font-size-11 rounded-sm p-1 sq-dbm1'>Flat {item.DISCOUNT}% OFF | Buy 5 Job Postings or more</p>
                                                            </div>} */}
                                                        </div>}

                                                    <div className="btn-box text-center mt-2 pt-0 sq-dbm1">
                                                        <a href="javascript:void(0)"
                                                            style={freeSubscribedPackages && item.PACKAGE_ID == freeSubscribedPackages.PACKAGE_ID ? { backgroundColor: "rgb(92 92 92 / 83%)", border: "1px solid rgb(161 160 161 / 83%)", color: 'white' } :{}}
                                                            data-plan-price={item.TOTAL_PRICE}
                                                            onClick={(e) => { this.startSubscription(e, item) }}
                                                            className="theme-btn w-100 sq-dbm1">

                                                            {freeSubscribedPackages && item.PACKAGE_ID == freeSubscribedPackages?.PACKAGE_ID ? 'Purchased' : 'Buy Now'}

                                                        </a>


                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {!tk && packages && packages.map((item, index) => {
                                        return (
                                            <div className="col-lg-20 pr-2">
                                                <div className="package-item">
                                                    <div className="price margin-bottom-20px">
                                                        <h3 className="price__title">{item.PACKAGE_TITE}</h3>
                                                        <p>{item.SUB_TITLE}</p>
                                                        <div className="package-info margin-top-20px">
                                                            <sup className="dollar">₹</sup>
                                                            <span className="amount">{item.TOTAL_PRICE}</span>
                                                        </div>
                                                        <h6 className='text-center pt-2'>All Cities</h6>
                                                    </div>
                                                    <ul className="list-items margin-bottom-50px pb-1">

                                                        {
                                                            item.PACKAGE_DETAILS.split('\n').map((ele, index) => {

                                                                return (
                                                                    <li><i className={ele.split(',')[0].trim() === 'yes' ? "la la-check-circle text-success" : 'la la-close text-danger'}></i> {ele.split(',').slice(1).join(',')} </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                    {item.SUB_TITLE != "Basic Job Posting" ?
                                                        <div className='row'>
                                                            {/* <div className='col-md-7 pb-2'>
                                                                <div className='d-flex align-items-center'>
                                                                    <p className='pr-2'>Quantity:</p>

                                                                    <select class="form-control p-0"
                                                                        value={item.QTY}
                                                                        onChange={(e) => { this.onChangeQty(item, e) }}
                                                                    >
                                                                        <option value="1">01</option>
                                                                        <option value="2">02</option>
                                                                        <option value="3">03</option>
                                                                        <option value="4">04</option>
                                                                        <option value="5">05</option>
                                                                        <option value="6">06</option>
                                                                        <option value="7">07</option>
                                                                        <option value="8">08</option>
                                                                        <option value="9">09</option>
                                                                        <option value="10">10</option>
                                                                    </select>


                                                                </div>
                                                            </div> */}
                                                            <div className={'col-md-5'}>
                                                                <div className='d-flex align-items-center'>
                                                                    <p className='pr-2'>Total:</p>
                                                                    <h6>₹{item.TOTAL_PRICE}</h6>
                                                                </div>
                                                            </div>

                                                            {/* {item.PRICE == 0 && <div className='col-md-12'>
                                                                <p className='bg-light font-size-11 rounded-sm p-1'>Flat {item.DISCOUNT}% OFF | Buy 5 Job Postings or more</p>
                                                            </div>} */}
                                                        </div> :

                                                        <div className='row'>
                                                            <div className='col-md-7 pb-2'>
                                                                <div className='d-flex align-items-center'>

                                                                </div>
                                                            </div>
                                                            <div className='col-md-7 pb-2'>
                                                                <div className='d-flex align-items-center'>
                                                                    <p className='pr-2'>Total:</p>
                                                                    <h6>₹{item.PRICE}</h6>
                                                                </div>
                                                            </div>
                                                            {/* {item.DISCOUNT != null && item.DISCOUNT > 0 && <div className='col-md-12'>
                                                                <p className='bg-light font-size-11 rounded-sm p-1'>Flat {item.DISCOUNT}% OFF | Buy 5 Job Postings or more</p>
                                                            </div>} */}
                                                        </div>}

                                                    <div className="btn-box text-center mt-2 pt-5">
                                                        <a
                                                            data-plan-price={item.TOTAL_PRICE}
                                                            href={constant.component.login.url}
                                                            className="theme-btn w-100">

                                                            {'Buy Now'}

                                                        </a>


                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {/* {packages&&
                                    <div className="col-lg-20 pr-2">
                                    <div class="package-item">
                                        <div class="price margin-bottom-20px">
                                            <h3 class="price__title">ENTERPRISE</h3>
                                            <p className='needmoh'>Need more?<br/>Reach out to get an offer</p>
                                            <h6 class="package-info margin-top-20px">
                                                <span className="amount sq-dbm1" style={{fontSize: "25px"}}> Custom Pricing</span>
                                                </h6>
                                                <h6 className='text-center pt-2'>All Cities</h6>
                                            <p>Tailored to your needs</p>
                                           
                                            </div>
                                            <ul class="list-items margin-bottom-10px pb-1">
                                                <li><i class="la la-check-circle text-success"></i> Featured Job Posting </li>
                                                <li><i class="la la-check-circle text-success"></i> Video Job Descriptions </li>
                                                <li><i class="la la-check-circle text-success"></i> Valid for all Cities</li>
                                                <li><i class="la la-check-circle text-success"></i> Auto Boost on Job Search </li>
                                                <li><i class="la la-check-circle text-success"></i> Free ATS</li>
                                                <li><i class="la la-check-circle text-success"></i> Free CRM</li>
                                                <li><i class="la la-check-circle text-success"></i> Ad Banner for 1 Year </li>
                                                <li><i class="la la-check-circle text-success"></i> Microsite </li>
                                                <li><i class="la la-check-circle text-success"></i> Automatic Sharing on Social Media </li>
                                            </ul>
                                            <div class="row">
                                                <div class="col-md-7 pb-2">
                                                    <div class="d-flex align-items-center"></div>
                                                    </div>
                                                </div>
                                            <div class="btn-box text-center mt-2 pt-1">
                                                <Link data-plan-price="0" to={constant.component.SalesEnquiry.url} class="theme-btn w-100">Contact Us</Link>
                                              
                                            </div>
                                        </div>
                                    </div>} */}
                                </div>
                                
                              <div className="row">
                                  <div className='col-md-12 pt-5 p-0 pr-2'>
                                    <div className='packgarblist'>
                                        <ul class="list-items mt-3">
                                            <li class="font-size-12 sq-db1"><i class="la la-check-circle-o mr-1"></i>For quantities upto 4, job posting credits should be consumed within 30 days from the date of activation/purchase.</li>
                                            <li class="font-size-12  sq-db2"><i class="la la-check-circle-o mr-1"></i>For quantities 5 and above, credits should be consumed within 1 year from the date of activation/purchase.</li>
                                            <li class="font-size-12  sq-db3"><i class="la la-check-circle-o mr-1"></i>Please note that the amounts are exclusive of taxes. Taxes will be added as applicable.</li>
                                            <li class="font-size-12  sq-db4"><i class="la la-check-circle-o mr-1"></i>Discount percentage have been rounded off to the nearest number.</li>
                                            <li class="font-size-12  sq-db5"><i class="la la-check-circle-o mr-1"></i>Metro cities include Delhi/NCR(National Capital Region), Delhi, Gurgaon, Noida, Greater Noida, Ghaziabad, Faridabad, Mumbai and Mumbai Suburbs, Thane, Navi Mumbai, Pune, Chennai, Bengaluru/Bangalore, Kolkata, Hyderabad/Secunderabad and Ahmedabad.</li>
                                        </ul>
                                    </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="hiw-area text-center padding-top-60px padding-bottom-50px">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="section-heading">
                                    <h2 class="sec__title font-size-20 mb-0">KEY BENEFITS</h2>
                                    <p class="sec__desc">Why Choose JobzShala Job Posting?</p>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-lg-4 responsive-column">
                                <div class="icon-box">
                                    <div class="icon-element">
                                        <i class="la la-clock"></i>
                                        <span class="info-number">1</span>
                                    </div>
                                    <div class="info-content mt-3">
                                        <h4 class="info__title mb-1">2 Minutes to Post</h4>
                                        <p class="info__desc line-height-20">Quick and easy to post job posting with highly optimised job posting form</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="icon-box">
                                    <div class="icon-element">
                                        <i class="las la-users"></i>
                                        <span class="info-number">2</span>
                                    </div>
                                    <div class="info-content mt-3">
                                        <h4 class="info__title mb-1">Attract Audience</h4>
                                        <p class="info__desc line-height-20">Reach to over 8.27 crore<br />talented jobseekers</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 responsive-column">
                                <div class="icon-box">
                                    <div class="icon-element">
                                        <i class="la la-calendar"></i>
                                        <span class="info-number">3</span>
                                    </div>
                                    <div class="info-content mt-3">
                                        <h4 class="info__title mb-1">30 days visibility</h4>
                                        <p class="info__desc line-height-20">Get quality applies guaranteed with 30 days visibility of your job ads.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="rg-haslayout rg-sectionspace sq-db2">
                    <div className="container sq-db2">
                        <div className="row sq-db2">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 sq-db2">
                                <div className="rg-sectionhead pb-4 sq-db2">
                                    <h2 className="blogheadline sq-db2">Latest Blogs</h2>
                                    <a target='_blank' className="rg-btnviewall" href={`https://jobzshala.com/blog`}>View All</a>
                                </div>
                            </div>
                            <div className="rg-topcompaniesholder sq-db2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 sq-db2">
                                    <div className="rg-topcompaniesslider rg-topcompanies blogheighbox sq-db2">
                                        {
                                            this.state.blogList && this.state.blogList.length > 0 ?
                                                this.state.blogList.map((item, index) => {
                                                    return (
                                                        <div className="rg-faqsourblog linefix item col-md-4 p-0 mr-3 sq-db2"  >
                                                            <a target='_blank' className="rg-bglight" href={`https://jobzshala.com/blog-detail/${item.URL}`} >
                                                                <img style={{ height: "233px", objectFit: "cover" }} src={`${process.env.REACT_APP_BASE_URL}/blog/Picture/${item.BLOG_IMAGE}`} alt="image description" />
                                                            </a>
                                                            <div className='p-4 sq-db2'>
                                                                <div target='_blank' className="rg-bglight blogtihead" href={`https://jobzshala.com/blog-detail/${item.URL}`}>
                                                                    <h3 className=''>
                                                                        <a target="_blank" href={`https://jobzshala.com/blog-detail/${item.URL}`}>{item.BLOG_TITLE}</a>
                                                                    </h3>
                                                                </div>
                                                                <div className="rg-bglight sq-db2">
                                                                    <p className='pb-5' style={{ textAlign: "left" }}>{Parser(item.BLOG_DETAILS.slice(0, 350))}...
                                                                        <span style={{ color: "#55acee" }}><a href={`https://jobzshala.com/blog-detail/${item.URL}`}>Read More</a></span></p>
                                                                </div>
                                                            </div>
                                                            <div className='autharname sq-db2'>
                                                                <div className='authimag pl-4 sq-db2'>
                                                                    <a target='_blank' className="rg-bglight" href={`https://jobzshala.com/blog-detail/${item.URL}`}>
                                                                        <img style={{ width: "36px", height: "36px", borderRadius: "50%", objectFit: "contain" }} src={authImage} />
                                                                    </a>
                                                                </div>

                                                                <div className='authorname-p sq-db2'>
                                                                    <a target='_blank' className="rg-bglight sq-db2" href={`https://jobzshala.com/blog-detail/${item.URL}`}>
                                                                        <p style={{ fontWeight: "500", padding: "10px 20px" }}>{item.AUTHOR}</p>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                ) : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                <section class="faq-area padding-top-60px padding-bottom-60px">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="section-heading">
                                    <h2 class="sec__title font-size-26 mb-2">HAVE ANY QUESTIONS?</h2>
                                    <p class="sec__desc font-size-16 line-height-26">See how can you make the most out of this situation
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="faqboxequal row margin-top-35px">
                            <div class="col-lg-4">
                                <div class="accordion accordion-item pr-4" id="accordionExample">
                                    <div class="card faqcardheight">
                                        <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link d-flex align-items-center justify-content-between" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <span className='font-size-16'>How do I post a job<br />on JobzShala?</span>
                                                    <i class="la la-minus"></i>
                                                    <i class="la la-plus"></i>
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div class="card-body">To post a job, log in to your Employer Login. Go to “Jobs & Responses" and click on the Job (classified or hot vacancy) link basis your subscription.
                                                <p><a target="_blank" href="https://jobzshala.com/faq" class="badge badge-light p-2">Read More <i class="la la-arrow-right"></i></a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="accordion accordion-item pr-4" id="accordionExample">
                                    <div class="card faqcardheight">
                                        <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link d-flex align-items-center justify-content-between" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <span className='font-size-16'>Difference between Hot Vacancy and Classified job posting?</span>
                                                    <i class="la la-minus"></i>
                                                    <i class="la la-plus"></i>
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div class="card-body">Classified Job Posting has limited job description (up to 250 characters) and absence of branding features for the Job. Hot Vacancy is the advanced Job Posting from JobzShala. It comes with No character limit for Job Description, exciting features like Job description (JD) import and JD suggestions(for select roles), Smart auto-fill of certain key fields, branding options and more.
                                                <p><a target="_blank" href="https://jobzshala.com/faq" class="badge badge-light p-2">Read More <i class="la la-arrow-right"></i></a></p></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="accordion accordion-item pr-4" id="accordionExample">
                                    <div class="card faqcardheight">
                                        <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link d-flex align-items-center justify-content-between" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <span className='font-size-16'>How can we promote a job posting?</span>
                                                    <i class="la la-minus"></i>
                                                    <i class="la la-plus"></i>
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div class="card-body">JobzShala offers value-added service of sharing your jobs on social media platform. You can also promote is as a Featured Job Listing, where your job gets displayed on top of the search results
                                                <p><a target="_blank" href="https://jobzshala.com/faq" class="badge badge-light p-2">Read More <i class="la la-arrow-right"></i></a></p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment >
        )
    }
}

